module.exports = __webpack_public_path__ + "img/3.191c998e.png";